import { useEffect, useMemo } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@shared/ui/dialog";
import { Button } from "@shared/ui/button";
import { DynamicForm } from "@shared/components/DynamicForm";
import { FormService, FormField } from "@shared/services/FormServices";
import { FIELD_CLASSES } from "@shared/utils/constants";
import { useUpdateFieldForce, useGetSkills } from "../../hooks";
import { mapToLabelValue } from "@shared/utils/mapToLabelValue";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";

interface Props {
  open: boolean;
  onClose: () => void;
  technician: any;
}

const AddSkillsDialog = ({ open, onClose, technician }: Props) => {
  const { mutate: updateFieldForce } = useUpdateFieldForce(
    technician?.fieldForceNo,
  );
  const remoteUtilityId = useRemoteUtilityId();
  const { data: skills } = useGetSkills();

  const skillOptions = useMemo(
    () => mapToLabelValue(skills, "skill", "id"),
    [skills],
  );

  const fields: FormField[] = useMemo(
    () => [
      {
        name: "skills",
        type: "multi-select",
        label: "Skills",
        options: skillOptions,
        className: "col-span-2",
      },
    ],
    [skillOptions],
  );

  const form = FormService.createForm({ fields })

  useEffect(() => {
    if(!technician) {
        return
    }
    if (technician?.skills) {
      form.setValue("skills", technician.skills);
    }
  }, [technician]);

  const handleSubmit = (data: any) => {
    const formData = new FormData();

    (data.skills ?? []).forEach((skill: string) => {
      formData.append("skills", skill);
    });

    formData.append("is_field_force_info", "true");
    formData.append("remote_utility_id", String(remoteUtilityId));

    updateFieldForce(formData, {
      onSuccess: onClose,
    });
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="">
        <DialogHeader>
          <DialogTitle>
            Add Skills - {technician?.name}
          </DialogTitle>
        </DialogHeader>

        <DynamicForm
          form={form}
          fields={fields}
          onSubmit={() => {}}
          gridColumns={2}
          renderCustomFooter={() => <></>}
          config={{ classes: FIELD_CLASSES }}
        />

        <div className="flex justify-end gap-3 pt-4 border-t">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={form.handleSubmit(handleSubmit)}
            className="bg-blue-600 hover:bg-blue-700"
          >
            Add
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AddSkillsDialog;
